// extracted by mini-css-extract-plugin
module.exports = {"InfDownLoadModal":"InfDownLoadModal--3PAjg"};